/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import PropTypes from 'prop-types';

interface IProps {
  round: string;
  market: string;
  possibleMarkets: string[];
  medianRoundSize: string;
  medianValCap: string;
  valCapDataLabel: string;
  dataPoints: string;
}

const SafeMarketData = (props: IProps) => {
  const {
    possibleMarkets,
    valCapDataLabel,
    round,
    market,
    medianRoundSize,
    medianValCap,
    dataPoints,
  } = props;

  return (
    <>
      <div className="row mb-4">
        <div className="col-12 col-md-12">
          <div className="card shadow">
            <div className="card-body">
              <form method="GET">
                <div className="row">
                  <div className="col-6">
                    <label htmlFor="round">Stage</label>
                    <select
                      className="custom-select mb-4"
                      data-choices
                      name="round"
                      required
                      defaultValue={round}
                    >
                      <option value="Pre-Seed">Pre-Seed</option>
                      <option value="Seed">Seed</option>
                      <option value="Seed+">Seed (Bridge)</option>
                    </select>
                  </div>
                  <div className="col-6">
                    <label htmlFor="market">Market</label>
                    <select
                      className="custom-select mb-4"
                      data-choices
                      name="market"
                      defaultValue={market}
                      required
                    >
                      {possibleMarkets.map((marketOption) => (
                        <option
                          key={marketOption}
                          value={marketOption}
                          selected={market === marketOption}
                        >
                          {marketOption}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <button
                  type="submit"
                  className="btn btn-secondary btn-block  btn-sm lift mb-4"
                >
                  Get AngelList market data
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-sm-12">
          <div className="card shadow">
            <div className="card-body">
              <div className="row mb-4">
                <div className="col-12 text-center">
                  <h3 className="">
                    {round} Stage Rounds ({market})
                  </h3>
                  {dataPoints && <small>{dataPoints}</small>}
                </div>
                <hr />
              </div>
              <div className="row">
                <div className="col-12 col-sm-6 text-center">
                  <h2>{medianRoundSize}</h2>
                  <strong className="mt-n2">Median Round Size</strong>
                </div>
                <div className="col-12 col-sm-6 text-center">
                  <h2>{medianValCap}</h2>
                  <strong className="mt-n2">
                    Median Valuation Cap ({valCapDataLabel})
                  </strong>
                </div>
              </div>
              <hr />
              <div className="row mt-6">
                <div className="col-12">
                  <h3 className="text-center">
                    Valuation Percentiles & Amount Raised
                  </h3>
                  <div className="px-12 mt-4">
                    <p>
                      Founders using AngelList get access to real time market
                      data including details about amounts raised, valuations by
                      percentile, dilution amounts, and more.
                    </p>
                    <hr />
                    <a
                      href="https://www.angellist.com/startups?ref=safeMarketData"
                      className="btn btn-block btn-primary mb-4"
                    >
                      Learn more about AngelList for Startups
                      <i className="fe fe-arrow-right ml-3" />
                    </a>
                  </div>
                  <img
                    src="https://storage.googleapis.com/al-stack-public/uploads/FHMous/blurred details.png"
                    className="img-fluid"
                    alt="Blurred details of Valuation Cap Percentiles"
                  />
                </div>
              </div>
              <hr />
              <a
                href="https://safe.new"
                className="btn btn-block btn-secondary"
              >
                Founders: Generate a SAFE instantly with SAFE.new
                <i className="fe fe-arrow-right ml-3" />
              </a>
              <hr />
              <small>Data from AngelList</small>
              <div className="float-right">
                <img
                  src="https://storage.googleapis.com/al-stack-public/uploads/lEf6Rq/AngelListStack2x.jpg"
                  className="navbar-brand-img float-right"
                  alt="logos"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

SafeMarketData.propTypes = {
  round: PropTypes.string.isRequired,
  market: PropTypes.string.isRequired,
  medianRoundSize: PropTypes.string.isRequired,
  medianValCap: PropTypes.string.isRequired,
  valCapDataLabel: PropTypes.string.isRequired,
  dataPoints: PropTypes.string.isRequired,
};

export default SafeMarketData;
